if (!customElements.get("product-button")) {
  customElements.define(
    "product-button",
    class ProductButton extends window.Component {
      constructor() {
        super();
        this.getContext();
        this.buttonElement = this;
        this.variantID = this.getVariant()?.id;
        this.modal = this.closest("dialog");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.quantity = this.getContext("quantity")?.toString();
        this.available = this.getState("available");
        this.buttonText = this.getState("button_text");
        this.actionEffect = this.getState("action_effect");
        this.addSubscribeContext();
        this.checkDisabled();
        this.buttonElement?.addEventListener("click", this.handleButtonClick);

        this.checkCartForVariant();
      }

      checkDisabled() {
        const inventory_quantity = isNaN(
          parseInt(this.inventoryQuantity ?? "0")
        )
          ? parseInt(this.inventoryQuantity ?? "0")
          : 0;
        if (this.available == true || inventory_quantity > 0) {
          this.hiddenButtonSoldOut();
        } else {
          this.showButtonSoldOut();
        }
      }

      getVariant() {
        return this.getContext("variantSelected");
      }

      addSubscribeContext() {
        this.subscribeContext((state, previousState) => {
          if (state.quantity !== undefined) {
            this.quantity = state.quantity?.toString() ?? "1";
          }
          if (state.variantSelected?.id === previousState.variantSelected?.id) {
            return;
          }
          if (this.variantSelectedID && state.variantSelected?.id) {
            this.variantSelectedID = state.variantSelected.id.toString();
          }
          this.variantID = state.variantSelected?.id;
          if (!this.buttonElement) {
            return;
          }
          if (state.variantSelected?.available) {
            this.hiddenButtonSoldOut();
          } else {
            this.showButtonSoldOut();
          }
          
          this.checkCartForVariant();
        });
      }

      #onLoading() {
        this.buttonElement?.setAttribute("data-state", "loading");
      }

      #offLoading() {
        this.buttonElement?.setAttribute("data-state", "idle");
      }

      showButtonSoldOut = () => {
        if (this.buttonElement) {
          this.buttonElement?.setAttribute("disabled", "true");
          const elementText = this.buttonElement.querySelector("span");
          elementText.textContent = "Sold Out";
        }
      };

      hiddenButtonSoldOut = () => {
        if (!this.buttonElement) return;
        const elementText = this.buttonElement.querySelector("span");
        elementText.textContent = this.buttonText || "Add to cart";
        this.buttonElement?.removeAttribute("disabled");
      };

      #parseInt(value, base = 10) {
        const parsed = parseInt(value, base);
        if (isNaN(parsed)) return 0;
        return parsed;
      }

      #getQuantity = () => {
        const quantity = this.#parseInt(this.quantity ?? "1");
        return quantity < 1 ? 1 : quantity;
      };

      goToCart = () => {
        window.location.href = "/cart";
      };

      // handleEffect() {
      //   switch (this.actionEffect) {
      //     case "checkout":
      //       this.goToCheckout();
      //       break;
      //     default:
      //       break;
      //   }
      // }

      disableQuantity() {
        const quantityElement = this.closest("product-wrapper").querySelector("product-quantity");
        if (quantityElement && typeof quantityElement.disableQuantityInput === "function") {
          quantityElement.disableQuantityInput();
        }
      }

      enableQuantity() {
        const quantityElement = this.closest("product-wrapper").querySelector("product-quantity");
        if (quantityElement && typeof quantityElement.enableQuantityInput === "function") {
          quantityElement.enableQuantityInput();
        }
      }

      checkCartForVariant() {
        window.getCart()
          .then((cart) => {
            const existingItem = cart.items.find((item) => item.id === this.variantID);
            if (existingItem && existingItem.quantity >= 6) {
              this.disableQuantity();
            } else {
              this.enableQuantity();
            }
          })
          .catch((err) => {
            console.error('Error checking cart for variant:', err);
          });
      }

      addToCartBtn() {
        this.#onLoading();
        window.getCart()
          .then((cart) => {
            let currentQuantity = 0;
            const existingItem = cart.items.find((item) => item.id === this.variantID);
            if (existingItem) {
              currentQuantity = existingItem.quantity;
            }
      
            const requestedQuantity = this.#getQuantity();
      
            if (currentQuantity >= 6) {
              this.disableQuantity();
              this.#offLoading();
              return;
            }
      
            let quantityToAdd = requestedQuantity;
            if (currentQuantity + requestedQuantity > 6) {
              quantityToAdd = 6 - currentQuantity;
            }
      
            const cartData = {
              items: [
                {
                  id: this.variantID,
                  quantity: quantityToAdd,
                },
              ],
              sections: "cart-drawer,cart-icon-bubble",
              section_url: window.location.pathname,
            };
      
            return fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify(cartData),
            });
          })
          .then(async (res) => {
            if (!res) return;
            if (res.ok) {
              return res.json();
            }
            return res.json().then((data) => {
              throw data;
            });
          })
          .then((res) => {
            if (res) {
              window.getCart()
                .then((cart) => {
                  const existingItem = cart.items.find(item => item.id === this.variantID);
                  if (existingItem && existingItem.quantity >= 6) {
                    this.disableQuantity();
                  } else {
                    this.enableQuantity();
                  }
                });
              this.cart.renderContents(res);
              this.#offLoading();
              this.modal?.close();
              document.body.style.overflow = '';
            }
          })
          .catch((err) => {
            this.#offLoading();
            console.error('Error adding to cart:', err);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }

      // goToCheckout() {
      //   window.location.href = "/checkout";
      // }

      handleButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setContext("isSubmit", true);
        this.addToCartBtn();
      };
    }
  );
}